// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qs6D","importantInfo":"styles_importantInfo__A9k_r"};